'use client';

import React, { useState } from 'react';
import resourcesData from '../../data/marketing-toolkit-slider-data.json';
import { CategorySection } from './CategorySection';

// Group resources by category
const digitalMarketing = resourcesData.slice(0, 21);
const printMarketing = resourcesData.slice(21, 25);
const marketingBundle = resourcesData.slice(25, 28);

const categories = [
  { title: 'Digital marketing assets', para: 'Digital PDFs can be printed for you. Simply tick the print option when you complete the form.', items: digitalMarketing, startIndex: 0 },
  { title: 'Print marketing materials', items: printMarketing, startIndex: 21 },
  { title: 'Marketing bundle', items: marketingBundle, startIndex: 25 },
];

export const MarketingAtFingerTipsDesktop = () => {
  const [hoveredIndex, setHoveredIndex] = useState(0);

  return (
    <div className="hidden lg:block container">
      <div className="hidden lg:grid lg:grid-cols-2 xl:grid-cols-[1.1fr,2fr] lg:gap-16">
        {/* Left Section - Image Preview */}
        <div className="flex items-center justify-center">
          <div className="sticky top-36">
            <div className="w-full overflow-hidden">
              <img
                key={hoveredIndex}
                src={resourcesData[hoveredIndex]?.imageDesktop}
                alt={resourcesData[hoveredIndex]?.title}
                className="w-full max-h-[calc(100vh-10rem)] transition-opacity duration-700 ease-in-out animate-fade-in object-contain"
              />
            </div>
          </div>
        </div>

        {/* Right Section - Content and Buttons */}
        <div>
          <p className="text-[#006EB7] font-semibold text-base md:text-xl mb-6">
            Marketing at your fingertips
          </p>

          <div className="flex justify-between items-start mb-6">
            <h2 className="text-4xl text-[#0C0D1A] font-semibold max-w-[30rem]">
              Tailored templates for your needs
            </h2>
            <a
              href="/professionals/resources/marketing-toolkit/request-toolkit"
              className="default-button-primary-large whitespace-nowrap"
            >
              Request a toolkit
            </a>
          </div>

          <p className="text-base text-[#5B5D6B] font-450">
            Promote your business and reach new clients with our print and digital marketing templates.
            Hover over the items to get a sneak peek of our ready-made resources and click the button to
            see more detailed examples. You can maximise your toolkit allowance with our ready-made print,
            digital and mixed bundles.
          </p>

          <p className="bg-[#F3F4F8] rounded-xl p-6 text-[#0C0D1A] font-medium mt-4 text-base mb-6">
            Build your own branded resources.{' '}
            <a
              href="https://puremediastorage.blob.core.windows.net/pure-web-media/toolkit/create-your-own-toolkit.pdf"
              className="plain-text-link--grey plain-text-link--underline"
              rel="noopener noreferrer nofollow"
              target="_blank"
            >
              Explore mix-and-match
            </a>
          </p>

          {categories.map((category, categoryIndex) => (
            <CategorySection
              key={categoryIndex}
              category={category}
              onResourceHover={setHoveredIndex}
              hoveredIndex={hoveredIndex}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
